import React from "react";
import { Alert, Paper, TextField, Typography } from "@mui/material";

interface ApiSpecEditorPanelProps {
  specContent: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
}

const ApiSpecEditorPanel: React.FC<ApiSpecEditorPanelProps> = ({
  specContent,
  onChange,
  readOnly = false,
}) => {
  let validationError: string | null = null;
  if (specContent.trim()) {
    try {
      JSON.parse(specContent);
    } catch {
      validationError = "Invalid JSON — fix before saving.";
    }
  }

  return (
    <Paper
      variant="outlined"
      sx={{ p: 2, height: 480, display: "flex", flexDirection: "column", minHeight: 0 }}
    >
      <Typography variant="subtitle2" gutterBottom>
        OpenAPI specification (JSON)
      </Typography>
      <TextField
        multiline
        fullWidth
        value={specContent}
        onChange={(e) => onChange(e.target.value)}
        disabled={readOnly}
        placeholder='{ "openapi": "3.0.3", ... }'
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          fontFamily: "monospace",
          fontSize: 12,
          "& .MuiInputBase-root": {
            flex: 1,
            alignItems: "stretch",
            overflow: "hidden",
          },
          "& textarea": {
            height: "100% !important",
            overflow: "auto !important",
            resize: "none",
          },
        }}
      />
      {validationError && (
        <Alert severity="warning" sx={{ mt: 1 }}>
          {validationError}
        </Alert>
      )}
    </Paper>
  );
};

export default ApiSpecEditorPanel;
